export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14292.91b299f2.jpg";